<template lang="pug">
#app
  router-view

  //- Ambos estaban importados, registrados y con su servicio instalado, pero
  //- sin montar en ningún template: $toast.add() y $confirm.require() no
  //- mostraban nada. Eso dejaba mudas las notificaciones de 80 componentes
  //- y las confirmaciones de borrado de otros 32.
  Toast(position="top-right")
  ConfirmDialog
</template>

<script>
import { useMeStore } from '@/stores/me';
import { useCategoriesStore } from '@/stores/categories';
import { useDownloadsStore } from '@/stores/downloads';
import { useBrandsStore } from '@/stores/brands';
import { useFundsCategoryStore } from '@/stores/funds-category';
import { useTransportsStore } from '@/stores/transports';
import { useSalesclerksStore } from '@/stores/salesclerks';
import { useWarehousesStore } from '@/stores/warehouses';


export default {
  name: 'App',
  computed: {
    showUser() {
      const meStore = useMeStore();
      return meStore.getUser;
    },
  },
  watch: {
    // TODO: Migrar este watcher a Pinia cuando se configuren los stores de datatable
    // showUser: {
    //   handler: function (newItem) {
    //     // Verificar que newItem existe y tiene id
    //     if (!newItem || !newItem.id) {
    //       return;
    //     }
    //     // Configurar Pusher para actualizaciones en tiempo real
    //     Pusher.logToConsole = import.meta.env.MODE !== 'production';
    //     var pusher = new Pusher(import.meta.env.VITE_APP_PUSHER_APPKEY, {
    //       cluster: 'sa1',
    //     });
    //     var channel = pusher.subscribe('refresh.' + newItem.id);
    //     // Bindings para actualización automática de datos
    //     const bindings = [
    //       'Allocation',
    //       'AllocationProvider',
    //       'Attribute',
    //       'AttributeType',
    //       'BankMovement',
    //       'Branchoffice',
    //       'BranchofficeConfig',
    //       'BranchofficeOption',
    //       'Brand',
    //       'BudgetDetail',
    //       'BudgetPayment',
    //       'Catalog',
    //       'Category',
    //       'Check',
    //       'Client',
    //       'ClientAccount',
    //       'Commission',
    //       'Configuration',
    //       'Coupon',
    //       'CreditCard',
    //       'CreditCardCoefficients',
    //       'Download',
    //       'DraftDetail',
    //       'EcommerceConfig',
    //       'EcommerceOrderDetail',
    //       'Fund',
    //       'FundCategory',
    //       'FundMovement',
    //       'MovementsStock',
    //       'Notification',
    //       'OrdernoteDetail',
    //       'PaymentMethod',
    //       'Payorder',
    //       'PayorderDetail',
    //       'PriceList',
    //       'ProdImage',
    //       'Product',
    //       'ProductPrice',
    //       'ProductPriceLog',
    //       'ProductVariant',
    //       'PromoRules',
    //       'Provider',
    //       'ProviderAccount',
    //       'Purchase',
    //       'PurchaseDetail',
    //       'Receipt',
    //       'ReceiptDetail',
    //       'SaleDetail',
    //       'Salepoint',
    //       'Salesclerk',
    //       'SendInvoice',
    //       'SerialNumber',
    //       'ShippingNoteDetail',
    //       'ShippingpurchaseDetail',
    //       'Stock',
    //       'TpCheck',
    //       'Transport',
    //       'UserEcom',
    //       'Warehouse',
    //       'Withholding',
    //     ];
    //     bindings.forEach(binding => {
    //       channel.bind(`created${binding}`, () => {
    //         this.$store.dispatch(`datatable${binding}/getData`);
    //       });
    //       channel.bind(`updated${binding}`, () => {
    //         this.$store.dispatch(`datatable${binding}/getData`);
    //       });
    //       channel.bind(`deleted${binding}`, () => {
    //         this.$store.dispatch(`datatable${binding}/getData`);
    //       });
    //     });
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    // Solo intentar obtener datos si hay token
    if (localStorage.getItem('token')) {
      this.getAuthUser();
      this.getCategories();
      this.getDownloads();
      this.getBrands();
      this.getFundsCategories();
      this.getTransports();
      this.getSalesclerks();
      this.getWarehouses();
    }
  },
  methods: {
    async getAuthUser() {
      const meStore = useMeStore();
      try {
        await meStore.fetchUser();
      } catch (error) {
        console.warn('No se pudo obtener datos del usuario:', error.message);
        // Si el token es inválido, limpiar y redirigir. No se llama a logout()
        // porque no hay nada que revocar: el servidor ya lo rechazó.
        if (error.response?.status === 401) {
          meStore.clearSession();
          this.$router.push('/auth/login');
        }
      }
    },
    getCategories() {
      const categoriesStore = useCategoriesStore();
      categoriesStore.getCategories();
    },
    getDownloads() {
      const downloadsStore = useDownloadsStore();
      downloadsStore.getDownloads();
    },
    getBrands() {
      const brandsStore = useBrandsStore();
      brandsStore.getBrands();
    },
    getFundsCategories() {
      const fundsCategoryStore = useFundsCategoryStore();
      fundsCategoryStore.getFundsCategories();
    },
    getTransports() {
      const transportsStore = useTransportsStore();
      transportsStore.getTransports();
    },
    getSalesclerks() {
      const salesclerksStore = useSalesclerksStore();
      salesclerksStore.getSalesclerks();
    },
    getWarehouses() {
      const warehousesStore = useWarehousesStore();
      warehousesStore.fetchWarehouses();
    },
  },
};
</script>
